module.exports = __webpack_public_path__ + "66c29b912f055e2cf041380a972dfd10.svg";